import type { PermissionDefinition } from '@ochal/module-sdk/contracts';

interface OwnedPermission { owner: string; definition: PermissionDefinition }
export class PermissionRegistry {
  private readonly permissions = new Map<string, OwnedPermission>();
  register(owner: string, definitions: readonly PermissionDefinition[]): void {
    for (const definition of definitions) if (this.permissions.has(definition.code)) throw new Error(`Duplicate permission: ${definition.code}`);
    for (const definition of definitions) this.permissions.set(definition.code, { owner, definition: Object.freeze({ ...definition }) });
  }
  unregisterOwner(owner: string): void { for (const [code, value] of this.permissions) if (value.owner === owner) this.permissions.delete(code); }
  list(): readonly PermissionDefinition[] { return [...this.permissions.values()].map((item) => item.definition); }
  has(code: string): boolean { return this.permissions.has(code); }
}
